export default "__VITE_ASSET__063f1704__"